import ResumeUpload from './components/resume/resume_upload.vue';
import Preview from './components/resume/preview.vue';
import ClientPreview from './components/resume/client_preview.vue';

export default {
  components: {
    ResumeUpload,
    Preview,
    ClientPreview,
  },
};
